module.exports = __webpack_public_path__ + "static/ornamen-union-5a8ced48993de89bf165f7d36a5a3fe0.png";